import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodSearchValidator } from '@tanstack/router-zod-adapter';
import z from 'zod';

import { UserStatus } from '../../types/UserStatus';
import { MembersPage } from '../user/list/MembersPage';

const filterSchema = z
    .object({
        role: z.array(z.string()).optional(),
        companies: z.array(z.string()).optional(),
        name: z.array(z.string()).optional(),
        email: z.array(z.string()).optional(),
    })
    .optional();

const customerGroupMembersSearchSchema = z.object({
    searchQuery: fallback(z.string(), '').default(''),
    customerIds: fallback(z.array(z.string()), []).default([]),
    status: z.nativeEnum(UserStatus).optional(),
    filter: filterSchema,
});

export const Route = createFileRoute('/_app/customer-groups/$groupId/members/')({
    validateSearch: zodSearchValidator(customerGroupMembersSearchSchema),
    component: MembersPage,
});
